module.exports = __webpack_public_path__ + "static/media/15a-01-HOME_ST-2015-405x295mm-oleo-sobre-papel.19eeba31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15a/15a-01-HOME_ST-2015-405x295mm-oleo-sobre-papel.jpg
// module id = 154
// module chunks = 0